// Upwardor — the original portal brand. Every value here is the colour or
// asset the portal shipped with before white-labelling; nothing visual changes
// for Upwardor when REACT_APP_BRAND=upwardor.
const upwardor = {
  key: "upwardor",
  name: "Upwardor",
  legalName: "Upwardor Inc.",
  title: "Upwardor Customer Portal",
  supportEmail: "info@upwardor.com",
  supportPhone: "+1800-667-3367", // shown on Customer Support (toll-free)

  assets: {
    logo: "/assets/img/upwardor-connect-FINAL.png", // light backgrounds (auth pages, sidebar)
    logoOnDark: "/assets/img/upwardor-connect-FINAL-white.png", // header bar
    mark: "/assets/img/upwardor-connect-FINAL.png", // collapsed sidebar
    favicon: "/assets/img/fav.png",
    loader: "/assets/img/loader.gif",
    loaderPulse: false,
    manifest: "/manifest.json",
    // Brand-coloured icon overrides: file name -> URL. Anything not listed
    // resolves to /assets/img/<file>.
    icons: {},
  },

  // Extra web-font stylesheets to load at boot (Inter is already in index.html).
  fonts: [],
  // Ant Design theme override; null keeps antd defaults.
  antd: null,
  dashboard: "classic",

  features: {
    // Bulk-panel quoting (BC customer flags Bulk_Resi_Panels / Bulk_Comm_Panels).
    bulkPanels: true,
    // Feedback-survey banner on the dashboard; link and wording from Admin > Customer Survey.
    customerSurvey: true,
  },

  // Design tokens -> CSS custom properties (--brand-<kebab-case>), see index.js.
  theme: {
    accent: "#808074",
    accentText: "#808074",
    accentHover: "#808074",
    accentDeep: "#6b6b60", // pressed/hover state of the Generate Quote button
    accentLight: "#808074",
    onAccent: "#ffffff",
    secondary: "#7561a2",
    secondaryAlt: "#765aa6",
    tabActive: "#1f7bf4",
    link: "#1E5DBC",
    badgeBg: "#D7F5FF",
    badgeText: "#197D9F",
    pillBg: "#e5edfa",
    inputIconBg: "#00358512",
    heroFrom: "rgba(45, 45, 45, 0.09)",
    fontDisplay: "'Inter', sans-serif",
    markUrl: "none",

    headerBg: "#808074",
    headerBorder: "transparent",

    navBg: "#f8f9fa",
    navBorder: "1px dashed #00000057",
    navLink: "#333333",
    navSubLink: "#333333",
    navText: "#202020",
    navSubText: "#5A5A5A",
    navIcon: "#898989",
    navLabel: "#7E8B99",
    navDot: "#596b77",
    navActiveBg: "#ffffff",
    navActiveText: "#707070",
    navHoverBg: "#D7F5FF",
    navHoverText: "#197D9F",
    navSubActiveText: "#808074",
    navSubActiveBg: "#e5edfa",
    navColSideHoverText: "#000000",
    navColSideHoverBg: "#1E5DBC26",
    navColSideHoverIcon: "#898989",
    navSidesActiveText: "#765aa6",
    navMaterialIcon: "#765aa6",

    authBgImage: "url(/assets/img/landing-img-comp.png)",
    authBgColor: "transparent",
    authBgSize: "cover",
  },
};

export default upwardor;
